import ReactPixel from 'react-facebook-pixel';
import {META_PIXEL} from "../enviroment";

const MetaPixel = () => {
    ReactPixel.init(META_PIXEL);
    ReactPixel.pageView();
    return null;
}

export default MetaPixel;